import {
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_REQUEST_SUCCESS,
  RESET_REQUEST_FAIL,
  CLEAR_ERRORS,
  REGISTER_FAILED
} from "../types";

const AuthReducer = (state, action) => {
  console.log("under auth reducer")
  switch (action.type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: action.payload,
      };

    case LOGIN_SUCCESS:
      localStorage.setItem("token", action.payload.token);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        loading: false,
      };

    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        error: action.payload,
      };

    case CHANGE_PASSWORD_SUCCESS:
      return { ...state, user: action.payload };

    case RESET_PASSWORD_SUCCESS:
      return { ...state, reset_message: action.payload };

    case RESET_REQUEST_SUCCESS:
      return { ...state, reset_request: action.payload };

    case CHANGE_PASSWORD_FAIL:
    case RESET_PASSWORD_FAIL:
    case RESET_REQUEST_FAIL:
      return { ...state, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default AuthReducer;
